<template>
  <div class="card modal-card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('selectionEcheance.title') }}
          </h1>&nbsp;
          <h3>
            {{ libellePiece() }}
          </h3>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content">
        <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'selectionEcheance.errors.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
        <b-table :data="mouvements" :bordered="true" :striped="true">
          <b-table-column field="dateEcheance"
                        v-slot="props"
                        :label="$t('selectionEcheance.columns.dateEcheance')">
            {{ props.row.dateMouvement  | formatDate }}
          </b-table-column>
          <b-table-column field="libelle"
                        v-slot="props"
                        :label="$t('selectionEcheance.columns.libelle')">
            {{ props.row.libelle }}
          </b-table-column>
          <b-table-column field="debit"
                        v-slot="props"
                        :label="$t('selectionEcheance.columns.debit')"
                        cell-class="right">
            {{ props.row.debit | formatDevise }}
          </b-table-column>
          <b-table-column field="credit"
                        v-slot="props"
                        :label="$t('selectionEcheance.columns.credit')"
                        cell-class="right">
            {{ props.row.credit | formatDevise }}
          </b-table-column>
          <b-table-column field="resteALettrer"
                        v-slot="props"
                        :label="$t('selectionEcheance.columns.resteALettrer')"
                        cell-class="right">
            {{ props.row.resteALettrer | formatDevise }}
          </b-table-column>
          <b-table-column field="etat"
                        v-slot="props"
                        :label="$t('selectionEcheance.columns.etat')">
            <router-link class="is-primary is-fullwidth"
                :class="[{ 'button-access-no-permission' :
                !checkPermissions(permRemises.maj) || isEscompte(props.row)},
                { 'pointer-events-none' :
                !checkPermissions(permRemises.maj) || isEscompte(props.row)}]"
                :to="{
                name: 'm.bodac.remises_bancaires-client',
                params: { id: props.row.id, isFromDetailClient: true } }">
              <b-icon :icon="isEscompte(props.row) ? 'eye-off' : 'eye'"
                      custom-size="mdi-18px"
                      :type="isEscompte(props.row) ? 'is-link' : 'is-primary'"/>
            </router-link>
            {{ $t(importedFunction.formatEtatLettrage(props.row.etatLettrage)) }}
          </b-table-column>
        </b-table>
        <footer class="mgt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.close')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import getLibelleAvecCategorieProduit from '@/services/compteClient/getLibelleAvecCategorieProduit';
import { getAll } from '@/api/mouvementClient/index';
import formatEtatLettrage from '@/services/general/formatEtatLettrage';
import { FACTURES, REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'popupSelectionEcheance',
  components: {
    errorMsgComponent,
  },
  props: {
    piece: {
      type: Object,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      mouvements: [],
      importedFunction: {
        formatEtatLettrage,
      },
      permFactures: FACTURES,
      permRemises: REMISES_BANCAIRES,
    };
  },
  methods: {
    libellePiece() {
      if (this.piece === undefined || this.piece === null) return '';
      return this.getLibelleTypeDePiece() + ' ' + this.piece.reference + ' - '
        + getLibelleAvecCategorieProduit(this.piece);
    },
    getLibelleTypeDePiece() {
      const type = mouvementClientConf.LISTE_TYPE_PIECE_VENTE.find((type) => {
        return type.code === this.piece.typeDePiece;
      });
      return type ? this.$i18n.t(type.libelle) : '';
    },
    isEscompte(mouvementClient) {
      if (mouvementClient === undefined || mouvementClient === null) return false;
      return mouvementClient.typeDePiece === mouvementClientConf.ESCOMPTE;
    },
    async loadMouvementClient() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          query: {
            societeId: this.societeId,
            factureId: this.piece.pieceId,
            brouillard: false,
          },
        };
        this.mouvements = (await getAll(params)).data.result.items;

        loadingComponent.close();
      } catch (error) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (error);
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  async mounted() {
    await this.loadMouvementClient();
  },
};
</script>

<style scoped>

</style>
